const administration = {
    app: {
        type: Object,
        required: true
    },
};
const portal = {
    app: {
        type: Object,
        required: true
    },
    account: {
        type: Object,
        required: true
    }
};
export { administration, portal };
